module.exports = __webpack_public_path__ + "static/media/Network.b12185fa.svg";